export default [
  {
    path: "quality/collar-stock",
    name: "CollarStock",
    component: () => import("@/pages/quality/CollarStock.vue"),
    meta: {
      title: "领标库存管理",
      requireAuth: true,
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/routes/quality.js